import { Grid } from '@mui/material';

import { InfoField } from '@occc-app/design-system';

type LocationAttributesCardProps = {
  attributes: string[];
};

export const LocationAttributesCard = ({ attributes }: LocationAttributesCardProps) => {
  const availableServices = attributes.length ? attributes.join(', ') : 'No services';

  return (
    <Grid item xs={12} md={4}>
      <InfoField
        sx={{ m: 0 }}
        label='Available Services'
        value={availableServices}
        noDataMessage=''
      />
    </Grid>
  );
};
